import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'db-ecommerce-view-body',
    templateUrl: './ecommerce-view-body.component.html',
    styleUrls: ['./ecommerce-view-body.component.scss'],
    standalone: false
})
export class EcommerceViewBodyComponent implements OnInit {
  @Input() heads: string[];
  @Input() headerGreedStyle: { [p: string]: string };
  @Input() headerGreedStyleRefund: { [p: string]: string };

  constructor() {
  }

  ngOnInit() {
  }

}
